import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { socket } from 'api';
import { notify } from 'libs/common';
import { RedButton } from '../oval-button/oval-button';
import { Content, ImgWrapper } from './alert-button.styled';

export const AlertButton = (props) => {
  const { t } = useTranslation();
  const [enabled, setEnabled] = useState(false);
  const rightSetStatus = window.haveRight('racks.fire_alarm');

  useEffect(() => {
    socket.on('racks.get_fire_alarm', (msg) => {
      setEnabled(msg.enable);
    });
    socket.call('racks.get_fire_alarm');

    return () => {
      socket.off('racks.get_fire_alarm');
    };
  }, []);

  const toggleFireAlert = () => {
    socket.call('racks.set_fire_alarm', { enable: !enabled });
    notify(t('widgets.Пожарная тревога'), t('widgets.Тревога отключена'), 'danger');
  };

  const showAlertPopup = () => {
    props.openWindow({
      id: 'AlertConfirmModal',
      type: 'alert_enable',
      data: {},
      header: t('widgets.Пожарная тревога'),
    });
  };

  if (!rightSetStatus) {
    return null;
  }

  return (
    <Content>
      <RedButton onClick={!enabled ? showAlertPopup : toggleFireAlert}>
        {!enabled ? t('widgets.Включить тревогу') : t('widgets.Отключить тревогу')}
        <ImgWrapper>
          <img style={{ width: '20px' }} src="/images/alarm.svg" alt="" />
        </ImgWrapper>
      </RedButton>
    </Content>
  );
};
